/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_Client_FullInputs */

const en_features_sample_client_full = /** @type {(inputs: Features_Sample_Client_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emma Clarke`)
};

const pl_features_sample_client_full = /** @type {(inputs: Features_Sample_Client_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ola Nowak`)
};

/**
* | output |
* | --- |
* | "Emma Clarke" |
*
* @param {Features_Sample_Client_FullInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_client_full = /** @type {((inputs?: Features_Sample_Client_FullInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_Client_FullInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_client_full(inputs)
	return en_features_sample_client_full(inputs)
});